import React from 'react'
import './index.scss'
import { Tooltip } from 'antd'

interface IFileRowProps {
  extensions: string[]
  description: string
  imgSrc: string
  tooltipTitle: string
}

const FileRow: React.FC<IFileRowProps> = ({ extensions, description, imgSrc, tooltipTitle }) => (
  <div className='optional-file-row'>
    {extensions.map((ext, index) => (
      <span key={index} className={`extention-type-${ext.replace('.', '')}`}>
        {ext}
      </span>
    ))}
    <span className='normal-text-tag'>{description}</span>
    <Tooltip title={tooltipTitle} placement='topLeft'>
      <img src={imgSrc} alt='info' />
    </Tooltip>
  </div>
)

export default FileRow
